<template>
  <div class="product-main-optional">
    <div class="product-main-optional-content">
      <div class="product-main-optional-head">
        Passendes Zubehör
      </div>

      <div class="product-main-optional-description">
        Wählen Sie Schritt für Schritt das passende Zubehör für {{ product.name | htmlDecode }} aus.
      </div>

      <div class="product-main-optional-action">
        <supplies-button
          :product="product"
        />
      </div>
    </div>

    <div class="product-main-optional-image">
      <img
        src="/assets/content/fence-accessoires.jpg"
      >
    </div>
  </div>
</template>

<script>
import { htmlDecode } from '@vue-storefront/core/filters'
import SuppliesButton from 'src/modules/vsf-supplies/components/SuppliesButton'

export default {
  name: 'Zaun24SuppliesBanner',
  components: {
    SuppliesButton
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  }
}
</script>
